import { Link } from "react-router-dom";
import { Users, Globe, Laptop, MessagesSquare, Check } from "lucide-react";
import {
  PageHero,
  ArrowLink,
  Reveal,
  FinalCTA,
  usePageMeta,
} from "../components/Common";
import { SERVICES } from "../data/content";

const SERVICE_ICONS = { users: Users, globe: Globe, laptop: Laptop, messages: MessagesSquare };

const Expertise = () => {
  usePageMeta(
    "Expertise — English for Leaders",
    "School leadership and strategic planning, international student recruitment, school partnerships and education technology — advisory grounded in practice.",
    "/expertise"
  );

  return (
    <div data-testid="expertise-page">
      <PageHero
        testid="expertise-hero"
        eyebrow="Expertise"
        title="Four disciplines. One standard: practical."
        intro="Advisory services grounded in leadership experience across Australia, Japan and Germany — every engagement shaped by work actually done in international schools."
      />

      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          {SERVICES.map((s, i) => {
            const Icon = SERVICE_ICONS[s.icon];
            return (
              <Reveal
                key={s.slug}
                className={`grid gap-8 py-14 lg:grid-cols-12 lg:gap-12 lg:py-16 ${
                  i > 0 ? "border-t border-navy/10" : ""
                }`}
              >
                <div className="lg:col-span-5">
                  <div className="flex items-center gap-4">
                    <span className="font-display text-4xl text-crimson/90" aria-hidden="true">
                      0{i + 1}
                    </span>
                    <Icon className="h-8 w-8 text-navy" strokeWidth={1.5} />
                  </div>
                  <h2 className="mt-5 font-display text-2xl leading-snug tracking-tight text-navy sm:text-3xl">
                    {s.title}
                  </h2>
                  <p className="mt-4 text-sm font-semibold leading-relaxed text-charcoal/60">
                    {s.audience}
                  </p>
                </div>
                <div className="lg:col-span-7">
                  <p className="text-base leading-relaxed text-charcoal/80 sm:text-lg">
                    {s.intro}
                  </p>
                  <ul className="mt-6 space-y-2.5">
                    {s.offerings.map((o) => (
                      <li key={o} className="flex items-start gap-3 text-sm leading-relaxed text-charcoal/80">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-crimson" strokeWidth={2.5} />
                        {o}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-7 flex flex-wrap items-center gap-x-7 gap-y-3">
                    <ArrowLink to={`/contact?interest=${s.slug}`} testid={`expertise-cta-${s.slug}`}>
                      {s.ctaLabel}
                    </ArrowLink>
                    <Link
                      to={`/expertise/${s.slug}`}
                      data-testid={`expertise-detail-link-${s.slug}`}
                      className="text-sm font-bold text-navy underline decoration-navy/30 underline-offset-4 transition-colors duration-300 hover:decoration-navy"
                    >
                      Explore this service
                    </Link>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <FinalCTA />
    </div>
  );
};

export default Expertise;
